import {
  ChangeDetectionStrategy,
  Component, EventEmitter, Input, OnChanges, OnInit, Output,
  SimpleChanges
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { getVisibleDates } from 'app/events/helpers/month-visible-dates';
import {
  add,
  getMonth,
  getYear,
  sub
} from 'date-fns';
import { CalendarEventResponseCoreFragment } from 'generated/graphql';
import { ListEventsDialog } from '../../dialogs/list-events/list-events.dialog';

@Component({
  selector: 'app-month-calendar',
  templateUrl: './month-calendar.component.html',
  styleUrls: ['./month-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonthCalendarComponent implements OnInit, OnChanges {
  @Input() entityId: string;
  @Input() events;
  @Input() loading = false;
  @Input() focusDate = new Date();
  @Output() visibleDatesChanged = new EventEmitter<{ focusDate: Date; startDate: Date; endDate: Date }>();
  @Output() eventResponseUpdated: EventEmitter<CalendarEventResponseCoreFragment> = new EventEmitter<CalendarEventResponseCoreFragment>();

  weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  today = new Date();
  currentDate = this.today;
  year = getYear(this.today);
  month = getMonth(this.today);
  calendarDays = [];
  maxEventsPerDay = 2; // 2 for mobile, 3 for tablet

  constructor(private _dialog: MatDialog, private _route: ActivatedRoute, private _router: Router) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.events) {
      this.updateDates(this.focusDate, false);
    }
  }

  ngOnInit() {
    this.updateDates(this.focusDate);
  }

  updateDates(date: Date, emitEvent = true) {
    const year = getYear(date);
    const month = getMonth(date);
    const { firstOfMonth, firstSunday, lastSaturday } = getVisibleDates(year, month);
    if (emitEvent) {
      this.visibleDatesChanged.emit({ focusDate: firstOfMonth, startDate: firstSunday, endDate: lastSaturday });
    }
    this.currentDate = firstOfMonth;
  }

  jumpToDate(date = new Date()) {
    this.updateDates(date);
  }

  prevMonth() {
    const monthBefore = sub(this.currentDate, { months: 1 });
    this.updateDates(monthBefore);
  }

  nextMonth() {
    const monthAfter = add(this.currentDate, { months: 1 });
    this.updateDates(monthAfter);
  }

  openListEventsDialog(data) {
    if (!data.events || data.events.length === 0) { return; }
    // Open dialog if more than one event, or viewing entity's events
    if (this.entityId || data.events.length > 1) {
      const dialog = ListEventsDialog.open(this._dialog, { data: { day: data, entityId: this.entityId } });
      dialog.componentInstance.onEventResponseUpdate.subscribe((response) => {
        this.eventResponseUpdated.emit(response);
      });
    } else if (data.events.length === 1) {
      // Single event on manage page, view it
      this.viewEvent(data.events[0].id);
    }
  }

  viewEvent(eventId) {
    this._router.navigate(['/events/view'], {
      queryParams: {
        campaignId: this._route.snapshot.queryParams['campaignId'],
        eventId
      }
    });
  }
}
